import { FeatureFlagConfig } from './feature-flag-config';
import { convertMsToSeconds } from '../time';

export class FeatureFlag {
    private _isOn: boolean = false;
    private startTs?: number = null;
    private finishTs?: number = null;

    public constructor(config?: FeatureFlagConfig) {
        if (!config) {
            return;
        }

        this._isOn = config?.isOn ?? false;
        this.startTs = config?.startTs ?? null;
        this.finishTs = config?.finishTs ?? null;
    }

    public isOn(): boolean {
        if (this._isOn !== true) {
            return false;
        }

        const currentTs = convertMsToSeconds(Date.now());

        if (this.startTs && currentTs < this.startTs) {
            return false;
        }

        if (this.finishTs && currentTs > this.finishTs) {
            return false;
        }

        return true;
    }
}
